import Vue from 'vue'
import store from 'store'
import { mapState } from 'vuex'
import $ from 'jquery'
import brandTagDisplay from 'mixins/brand-tag'

export default el => Promise.all([
  enqueueModule('product-form.vue'),
  enqueueModule('product-hero.vue')
]).then(() => new Vue({
  el,
  store,
  mixins: [brandTagDisplay],
  computed: {
    ...mapState('product', [
      'product'
    ])
  },
  mounted () {
    $(document).on('click', '.js-tab-wrapper .js-tab-item .js-tab-item-title', function (e) {
      e.preventDefault()
      const $item = $(this).closest('.js-tab-item')
      const $cover = $(this).closest('.js-tab-wrapper')
      $cover.find('.js-tab-item').not($item).removeClass('active')
      $item.toggleClass('active')
    })

    $(document).on('click', '.js-size-guide-trigger', function (e) {
      e.preventDefault()

      if ($('.js-product-size-popup').hasClass('active')) {
        $('.js-product-size-popup').removeClass('active')
      } else {
        $('.js-product-size-popup').addClass('active')
      }
    })

    $(document).click(function (e) {
      if ($(e.target).closest('.js-product-size-popup, .js-size-guide-trigger').length === 0) {
        $('.js-product-size-popup').removeClass('active')
      }
    })
  }
}))
